export { DuplicatePageButton } from './DuplicatePageButton';
